
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'
import {CSSTransitionGroup} from 'react-transition-group'

function FirstChild(props) {
  const children = React.Children.toArray(props.children)
  return children[0] || null
}

export default class Select extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    emptyValue: PropTypes.string,
    disabled: PropTypes.bool,
    searchable: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      disabled: PropTypes.bool
    })),
    onBlur: PropTypes.func,
    onSelect: PropTypes.func,
    invalid: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }

  static defaultProps = {
    options: []
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      searchText: ''
    }
  }

  componentWillUpdate(props, state) {
    if (state.opened) {
      document.addEventListener('click', this.hideSelectList)
    } else {
      document.removeEventListener('click', this.hideSelectList)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideSelectList)
  }

  render() {
    const {opened} = this.state
    const {className, value, disabled, invalid} = this.props
    const selectClassName = classnames('select', className, {
      'is-opened': opened,
      'is-disabled': disabled,
      'is-invalid': invalid
    })
    const selectLabelClassName = classnames('select_label', className ? `${className}_label` : '')
    const iconClassName = classnames('select_label-icon', className ? `${className}_label-icon` : '')

    return (
      <div className={selectClassName} onClick={this.onClick}>
        <div className={selectLabelClassName}>
          <span>
            {this.getOptionName(value)}
          </span>
          <Icon
            name='new-arrow-up'
            className={iconClassName}
            size='10px'
          />
        </div>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName='is-transition'
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.renderItems()}
        </CSSTransitionGroup>
      </div>
    )
  }

  renderItems() {
    const {opened} = this.state
    const {className} = this.props
    const listClassName = classnames('select_list', className ? `${className}_list` : '')

    if (opened) {
      return (
        <div className='select_body'>
          {this.renderSearch()}
          <ul className={listClassName}>
            {this.renderFilteredOptions()}
          </ul>
        </div>
      )
    } else {
      return null
    }
  }

  renderSearch() {
    const {searchable} = this.props
    const {searchText} = this.state

    if (!searchable) return null

    return (
      <div className='select_search'>
        <Icon
          name='zoom'
          className='select_search_icon'
          size='10px'
        />
        <input
          className='select_search_input'
          type='text'
          autoFocus
          onClick={this.onSearchClick}
          onInput={this.onSearchType}
          value={searchText}
        />
        <Icon
          name='cross'
          className='select_search_clear'
          size='10px'
          onClick={this.onSearchClearClick}
        />
      </div>
    )
  }

  renderFilteredOptions() {
    const {searchText} = this.state
    const {options, searchable} = this.props

    if (!searchable || !searchText) return options.map(this.renderOption)

    const filteredOptions = options.filter(option => {
      const name = option.name.toLowerCase()
      return name.includes(searchText)
    })

    if (filteredOptions.length) {
      return filteredOptions.map(this.renderOption)
    } else {
      return <li className='select_list-item'>No results found.</li>
    }
  }

  renderOption = (option, index) => {
    const {className} = this.props
    const {type, disabled} = option
    const itemClassName = classnames('select_list-item', {
      [`${className}_list-item`]: className,
      [`is-${type}`]: type,
      'is-disabled': disabled
    })
    const onItemClick = this.onItemClick.bind(this, option)

    return (
      <li
        className={itemClassName}
        onClick={onItemClick}
        key={index}
      >
        {option.name}
      </li>
    )
  }

  onClick = e => {
    e.stopPropagation()
    const {disabled, onBlur} = this.props
    if (disabled) return false

    if (this.state.opened && onBlur) onBlur()
    this.setState({
      opened: !this.state.opened
    })
  }

  onItemClick = (option, e) => {
    const {disabled} = option
    e.stopPropagation()
    if (disabled) return null

    const {onSelect} = this.props
    onSelect && onSelect(option)
    this.hideSelectList()
  }

  onChange = e => {
    const {onSelect} = this.props
    onSelect(e.target.value)
  }

  onSearchClick = e => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
  }

  onSearchType = e => {
    this.setState({
      searchText: e.target.value ? e.target.value.toLowerCase() : ''
    })
  }

  onSearchClearClick = e => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    this.setState({
      searchText: ''
    })
  }

  getOptionName(value) {
    const {options, emptyValue} = this.props
    const option = options.filter(option => option.value === value)

    if (option.length) {
      return option[0].name
    } else {
      return emptyValue || '...'
    }
  }

  hideSelectList = () => {
    const {onBlur} = this.props
    if (this.state.opened && onBlur) onBlur()
    this.setState({
      opened: false,
      searchText: ''
    })
  }
}



// WEBPACK FOOTER //
// ./client/components/Select/index.js